// extracted by mini-css-extract-plugin
export var currencyInput = "_mb-1";
export var currencySymbol = "_mb-0";